export function convertToCSSPrefix(property: string): string {
  return property
    .replace(/^Moz/, "-moz-")
    .replace(/^ms/, "-ms-")
    .replace(/^O/, "-o-")
    .replace(/^Webkit/, "-webkit-")
    .toLowerCase();
}

export default convertToCSSPrefix;



// WEBPACK FOOTER //
// ./src/utils/convertToCSSPrefix.ts